import { styled } from '@mui/material/styles';
import { Box, Card, Grid, Typography } from '@mui/material';

const commonContainerStyles = {
  margin: '1% auto',
  padding: '1%',
  marginTop: '14px',
  backgroundColor: 'white',
  borderRadius: '5px',
};

const commonTextStyles = {
  fontSize: '12.71px',
  fontWeight: 600,
  lineHeight: '15.49px',
  textalign: 'right',
};

export const ResultDataContainer = styled(Grid)({
  ...commonContainerStyles,
  maxWidth: '1265.01px',
  boxShadow: '0 3px .625pc 0 rgb(0 0 0 / 6%) !important',
});

export const ScenarioOverviewContainer = styled(Box)({
  ...commonContainerStyles,
  width: '100%',
});

export const ScenarioOverviewLabel = styled(Typography)({
  fontSize: 16,
  fontWeight: 600,
  lineHeight: '19.5px',
  marginBottom: '10px',
});

export const OverviewDataContainer = styled(Grid)({
  display: 'grid',
  gridTemplateColumns: '22% 59% 19%',
  width: '100%',
  margin: '0 auto',
});

export const BaseCardContainer = styled(Grid)({
  display: 'grid',
  gridTemplateColumns: '20% 40% 40%',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  height: '46.3px',
  background: '#F7F8FB',
});

export const BaseCard = styled(Grid)({
  display: 'grid',
  gridTemplateColumns: '20% 40% 40%',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  height: '46.3px',
  background: '#F7F8FB',
});

export const BaseCardData = styled(Grid)({
  display: 'grid',
  gridTemplateColumns: '20% 40% 40%',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  height: '46.3px',
  background: '#F7F8FB',
});

export const ScenarioCardsContainer = styled('div')({
  display: 'flex',
  whiteSpace: 'nowrap',
  marginLeft: '20px',
  marginRight: '10px',
  overflowX: 'auto',
  paddingBottom: '5px',
  '&:hover': {
    overflowX: ' auto',
  },
});

export const ScenarioCards = styled(Card)({
  width: '120px',
  height: '463px',
  marginRight: '15px',
  textAlign: 'center',
  flexShrink: 0,
  border: '0.91px solid red',
});

export const ScenarioCardText = styled(Typography)({
  ...commonTextStyles,
});

export const BaseCardText = styled(Typography)({
  ...commonTextStyles,
});
